<div class="col-12">
  <form class="login-form"
        [formGroup]="form"
        (ngSubmit)="submit()">
    <div class="title">
      <span class="text">{{ 'auth.activation.title' | translate }}</span>
    </div>

    <div *ngIf="config$ | async as config" class="subtitle">
      <span class="text">{{ 'auth.activation.subtitle' | translate: {platform: config.productName} }}</span>
    </div>

    <cap-input formControlName="email"
               [label]="'auth.username.label' | translate"
               [placeholder]="'auth.username.placeholder' | translate">
    </cap-input>

    <cap-input formControlName="password"
               type="password"
               [label]="'auth.activation.password.label' | translate"
               [placeholder]="'auth.password.placeholder' | translate">
    </cap-input>

    <cap-input formControlName="password_confirmation"
               type="password"
               [label]="'auth.activation.confirm-password.label' | translate"
               [placeholder]="'auth.password-confirmation.placeholder' | translate">
    </cap-input>

    <div class="flex-buttons">
      <cap-button routerLink="/auth/login"
                  styleClass="secondary"
                  type="button"
                  [label]="'auth.forgot-password.button.back' | translate">
      </cap-button>

      <cap-button styleClass="primary"
                  type="submit"
                  [label]="'auth.activation.submit' | translate">
      </cap-button>
    </div>
  </form>
</div>
